import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './BreakdownItem.css';
import Input from 'components/shared/input/Input';
import { Row } from 'react-bootstrap';
import removeIconPng from 'images/remove.png';
import TextareaAutosize from 'react-autosize-textarea';

import {
  removeBreakdownItem,
  updateBreakdownItem,
} from 'actions/admin/work-orders/details/proposal';

class BreakdownItem extends Component {
  static propTypes = {
    concept: PropTypes.string,
    unit_number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    unit_type: PropTypes.string,
    cost: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ext: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  componentDidUpdate(prevProps) {
    const item = this.props.breakdownItem;
    // if the change is on the unit_number or the cost
    if (
      item.unit_number !== prevProps.breakdownItem.unit_number ||
      item.cost !== prevProps.breakdownItem.cost
    ) {
      // if the change is not on the 'ext' property
      if (prevProps.breakdownItem.ext === item.ext) {
        const ext =
          parseFloat(item.unit_number || 0) * parseFloat(item.cost || 0);
        this.handleBreakDownItemChange(this.props.itemIndex, 'ext', `${ext}`);
      }
    }
  }

  handleRemoveBreakdownItemClick = (biIndex) => {
    this.props.dispatch(removeBreakdownItem(this.props.itemId, biIndex));
  };

  handleBreakDownItemChange = (biIndex, key, value) => {
    this.props.dispatch(
      updateBreakdownItem(this.props.itemId, biIndex, key, value)
    );
  };

  render() {
    const breakdownItem = this.props.breakdownItem;
    const index = this.props.itemIndex;
    return (
      <Row>
        <TextareaAutosize
          rows={1}
          id={`breakdown-item-${index}-concept`}
          value={breakdownItem.concept}
          onChange={(e) =>
            this.handleBreakDownItemChange(index, 'concept', e.target.value)
          }
        />

        <Input
          id={`breakdown-item-${index}-unit_number`}
          placeholder="units"
          type="number"
          value={breakdownItem.unit_number}
          theme="normal"
          className="small"
          onChange={this.handleBreakDownItemChange.bind(
            this,
            index,
            'unit_number'
          )}
        />

        <Input
          id={`breakdown-item-${index}-unit_type`}
          placeholder="type"
          value={breakdownItem.unit_type}
          theme="normal"
          className="small"
          onChange={this.handleBreakDownItemChange.bind(
            this,
            index,
            'unit_type'
          )}
        />

        <Input
          id={`breakdown-item-${index}-cost`}
          placeholder="cost"
          type="number"
          value={breakdownItem.cost}
          theme="normal"
          onChange={this.handleBreakDownItemChange.bind(this, index, 'cost')}
        />

        <Input
          id={`breakdown-item-${index}-ext`}
          placeholder="ext"
          type="number"
          value={breakdownItem.ext}
          theme="normal"
          onChange={this.handleBreakDownItemChange.bind(this, index, 'ext')}
        />

        <img
          id={`remove-bi-${index}`}
          src={removeIconPng}
          className="bi-remove"
          alt="remove"
          onClick={this.handleRemoveBreakdownItemClick.bind(this, index)}
        />
      </Row>
    );
  }
}

export default connect()(BreakdownItem);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/proposals/BreakdownItem.js